module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7r8r5r1n-a95302188cbc87b7fd8ebe40911a089e.svg";